// Login – simple, elegant layout: tagline (Train + rotating Classification/Detection) + form

import useLogin from './hooks/useLogin';
import MainSection from './components/MainSection.jsx';
import LoginPageBackground from './components/LoginPageBackground.jsx';
import LoginTagline from './components/LoginTagline.jsx';
import './styles/login.css';

export default function Login() {
  const { handlers } = useLogin();
  return (
    <div className="auth-wrapper auth-wrapper--simple">
      <LoginPageBackground />
      <div className="auth-layout auth-layout--simple">
        <div className="auth-hero">
          <div className="auth-hero__inner">
            <h1 className="auth-hero__headline">
              <LoginTagline />
            </h1>
            <div className="auth-hero__tagline-wrap">
              <p className="auth-hero__tagline">
                One platform for the full ML lifecycle—from data to deployment.
              </p>
            </div>
            <ul className="auth-hero__features">
              <li className="auth-hero__feature">
                <span className="auth-hero__feature-num">1</span>
                <span className="auth-hero__feature-text"><strong>Label & prepare</strong> — Annotate images for classification and detection, manage datasets and versions.</span>
              </li>
              <li className="auth-hero__feature">
                <span className="auth-hero__feature-num">2</span>
                <span className="auth-hero__feature-text"><strong>Train</strong> — Build and train vision models with your labeled data in a single workflow.</span>
              </li>
              <li className="auth-hero__feature">
                <span className="auth-hero__feature-num">3</span>
                <span className="auth-hero__feature-text"><strong>Test & evaluate</strong> — Validate performance, compare versions, and iterate with confidence.</span>
              </li>
              <li className="auth-hero__feature">
                <span className="auth-hero__feature-num">4</span>
                <span className="auth-hero__feature-text"><strong>Deploy</strong> — Export and deploy trained models for inference in your applications.</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="auth-content">
          <MainSection handlers={handlers} />
        </div>
      </div>
    </div>
  );
}
